import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4f0ed16e&scoped=true&"
import script from "./index.vue?vue&type=script&setup=true&lang=ts&"
export * from "./index.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=4f0ed16e&prod&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=4f0ed16e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0ed16e",
  null
  
)

export default component.exports